<template>
    <div class="warp">
        <div v-if="!loading">
            <div class="head">
                <div>
                    <p v-if='sid==21||sid==22'
                       class="title">{{unit_name}}数学{{testname}}<span v-if="testType!=4">作业</span>报告</p>
                    <p v-else
                       class="title">{{unit_name}}{{sid==51?'语文':'英语'}}{{testname}}作业报告</p>
                    <p @click="back()"
                       class="back"></p>
                </div>
            </div>
            <div class="top_con">
                <img :src="tea_portrait">
                <div>
                    <h3 class="teaname">{{tea_name}}</h3>
                    <!-- 速算 -->
                    <p v-if="sid==21&&taskType==2&testType==4">本次<span>{{testname}}</span>，班级平均分<span>{{avg_score}}</span>分，班级最高分<span>{{max_score}}</span>分，平均用时<span>{{time}}</span>。建议登录同步课堂APP，查看自己孩子的作业情况。</p>
                    <!-- 知识点视频 -->
                    <p v-if="taskType==1||(sid==51&&taskType==2&&testType==4)"><span>{{testname}}作业</span>，帮助孩子提前熟悉课本知识，提升听课效率。建议登录同步课堂APP，查看自己孩子的预习情况。</p>
                    <!-- 作业 -->
                    <p v-if="(taskType==2&testType!=4&sid==21||sid==22)||(sid==51&&(taskType==2||taskType==4)&&testType!=4)||(taskType==2&&(sid==91||sid==92))">本次<span>{{testname}}</span>作业，班级平均分<span>{{avg_score}}</span>分，班级最高分<span>{{max_score}}</span>分。建议登录同步课堂APP，查看自己孩子的作业情况。</p>
                </div>
            </div>
            <div class="con">
                <div :class="['box',{'yx':(taskType==2&&testname!='生词听写')||taskType==4,'jj':taskType==1||testname=='生词听写'}]">
                    <div class="content">
                        <div :class="['stu',{'first':index==0,'second':index==1,'third':index==2}]"
                             v-for="(stu,index) in stulist"
                             v-if="stulist.length>0">
                            <img :src="stu.user_portrait">
                            <p class="name">{{stu.real_name}}</p>
                            <p class="day">{{index+1}}</p>
                        </div>
                        <div class="nolist"
                             v-if="stulist.length==0">
                            暂无学生完成
                        </div>
                    </div>
                </div>
            </div>
            <div class="share"
                 @click="share">
                <p>分享至班群</p>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import Vheader from 'SRC/components/base/header.vue';
import loadingS from 'SRC/components/base/tealoading.vue';
export default {
    name: "winter",
    components: {
        Vheader,
        loadingS
    },
    data () {
        return {
            // title:'',
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            uid: this.$route.params.uid, //班级id
            taskId: Number(this.$route.params.taskId), //作业id
            taskType: Number(this.$route.params.taskType), //作业类型1课前2课后3课外
            testType: Number(this.$route.params.testType),
            sid: Number(this.$route.params.sid),
            tea_name: "",
            tea_portrait: '',
            unit_name: "",
            stulist: [],
            btnShare: true,
            testname: '',
            max_score: '', // 最高分数
            avg_score: '', // 平局分数
            time: '', // 平均用时
            testTime: '', //作业日期
            teaId: JSON.parse(localStorage.getItem('info')).user_id,
            loading: true,
            is_active: Number(this.$route.query.is_active) || 0, //期末活动
            tbkt_token: localStorage.getItem('Tbkt-Token'),
            info: JSON.parse(localStorage.getItem('info')),
            region_name: '',
        }
    },
    computed: {
        className () {
            return this.$store.state.class_name || '';
        },
    },
    created () {
        //console.log(this.taskType, this.testType)
        this.region_name = this.info.platform_config.region_name;
        let _url = '';
        if (this.sid == 21 || this.sid == 22) {
            _url = '/maths/check/share/math?unit_class_id=' + this.uid + '&message_id=' + this.taskId +
                '&task_type=' + this.taskType + '&test_type=' + this.testType + '&tea_id=' + this.teaId +
                '&region_name=' + this.region_name;
        }
        if (this.sid == 51) {
            let taskType = this.testType;
            if (this.taskType == 1 && this.testType == 2) {
                taskType = 5;
            }
            if (this.taskType == 4 && this.testType == 1) {
                taskType = 6;
            }
            _url = '/chinese/check/share/chinese?unit_class_id=' + this.uid + '&message_id=' + this.taskId +
                '&task_type=' + taskType + '&test_type=' + this.testType + '&tea_id=' + this.teaId +
                '&region_name=' + this.region_name;
        }
        if (this.sid == 91 || this.sid == 92) {
            let taskType = this.testType;
            if (this.taskType == 1) {
                taskType = 2;
            }
            _url = '/english/check/share/english?unit_class_id=' + this.uid + '&message_id=' + this.taskId +
                '&task_type=' + taskType + '&test_type=' + this.testType + '&tea_id=' + this.teaId +
                '&region_name=' + this.region_name;
        }
        let url = API_URL_TASK_API + _url;
        this.$http.get(url).then(res => {
            this.loading = false;
            if (res.data.response == "ok") {
                res = res.data.data;
                this.testname = this.is_active ? '暑假' : res.test_name;
                this.tea_portrait = res.tea_portrait;
                this.stulist = res.rank;
                this.tea_name = res.tea_name;
                this.unit_name = res.unit_name;
                this.max_score = res.max_score;
                this.avg_score = res.avg_score;
                this.time = res.avg_time;
                this.testTime = this.is_active ? '' : res.end_date;
            }
        })
    },
    methods: {
        share () {
            let that=this
            if (!this.btnShare) {
                return false;
            }
            this.btnShare = false;
            let url = VUE_URL_HD + "/#/shareMathTask/index/" + this.uid + "/" + this.taskId + "/" + this.taskType +
                "/" + this.testType + "/" + this.teaId + '?is_active=' + this.is_active + "&sid=" + this.sid +
                '&tbkt_token=' + this.tbkt_token + '&region_name=' + this.region_name,
                title = this.unit_name + this.testTime + (this.sid == 21 || this.sid == 22 ? '数学' : this.sid == 51 ?
                    '语文' : '英语') + this.testname + "作业报告，请家长们注意查收！",
                content = "这些学生表现非常棒，值得鼓励和表扬。";
            if (this.testType == 4 && this.sid == 21) { //速算
                title = this.unit_name + this.testTime + "数学" + this.testname + "报告，请家长们注意查收！";
            }
            // try {
            //     appobject.Interactive(`ys_share,${title},${content},${url}`)
            //     this.btnShare = true;
            // } catch (e) {
            //     this.btnShare = true;
            //     //console.log(`ys_share,${title},${content},${url}`)
            // }
            if(this.inApp){
                this.appFunction("ys_share", `${title},${content},${url},${this.sid},${this.uid},0,0,教师检查作业分享报告给家长`);
            }else{
                let coptText=`${title},${content},链接：${url}`
                layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                    layer.close(index)
                    that.copyText(coptText);
                }, '分享链接复制成功')
            }
            this.btnShare = true;
        },
         copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

.warp {
    width: 100%;
    padding-top: 100px / $ppr;
}

.head {
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    div {
        width: 100%;
        height: 96px / $ppr;
        position: relative;

        .title {
            width: 100%;
            height: 96px / $ppr;
            text-align: center;
            line-height: 96px / $ppr;
            color: #fff;
            font-size: 34px / $ppr;
        }

        .back {
            width: 18px / $ppr;
            height: 36px / $ppr;
            background: url(./img/choose_back.png) no-repeat;
            background-size: 100%;
            position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
        }

        .preview {
            position: absolute;
            top: 30px / $ppr;
            right: 24px / $ppr;
            font-size: 28px / $ppr;
            z-index: 10;
            color: #fff;
        }
    }
}

.top_con {
    width: 650px / $ppr;
    margin: 25px / $ppr auto 0;

    img {
        display: inline-block;
        width: 80px / $ppr;
        height: 80px / $ppr;
        vertical-align: top;
        border-radius: 40px / $ppr;
    }

    div {
        h3 {
            color: #333;
            font-size: 30px / $ppr;
        }

        display: inline-block;
        width: 560px / $ppr;
        color: #999;
        font-size: 30px / $ppr;

        span {
            color: #ff6600;
        }
    }
}

.con {
    margin-top: 60px / $ppr;
}

.box {
    width: 672px / $ppr;
    height: 598px / $ppr;
    margin: 0 auto;
    position: relative;
    z-index: 3;

    // box-shadow:-5px/$ppr 0px 10px/$ppr darkgrey,   /*左边阴影*/
    //             0px -5px/$ppr 10px/$ppr darkgrey,  /*上边阴影*/
    //             5px/$ppr 0px 10px/$ppr darkgrey,  /*右边阴影*/
    //             0px 5px/$ppr 10px/$ppr darkgrey; /*下边阴影*/
    i {
        display: block;
    }

    .content {
        width: 572px / $ppr;
        padding: 200px / $ppr 50px / $ppr 0;
        height: 360px / $ppr;
        position: relative;

        .stu {
            width: 158px / $ppr;
            // height:360px/$ppr;
            position: absolute;
            z-index: 3;
            text-align: center;
            font-size: 24px / $ppr;
            color: #999;

            img {
                display: block;
                width: 120px / $ppr;
                height: 120px / $ppr;
                border-radius: 50%;
                background: #fff;
                margin: 10px / $ppr auto;
            }

            .name {
                line-height: 34px / $ppr;
            }

            .day {
                color: #fff;
                line-height: 80px / $ppr;
                height: 80px / $ppr;
                border-radius: 12px / $ppr;
                margin-top: 10px / $ppr;
                font-size: 72px / $ppr;
            }
        }

        .first {
            bottom: 0;
            left: 50%;
            margin-left: -79px / $ppr;

            // height:400px/$ppr;
            img {
                width: 158px / $ppr;
                height: 158px / $ppr;
            }

            .day {
                background: #f3d71d;
                padding: 40px / $ppr 0;
            }
        }

        .second {
            left: 50px / $ppr;
            // top:255px/$ppr;
            bottom: 0;

            .day {
                padding: 19px / $ppr 0;
                background: #bfd0d3;
            }
        }

        .third {
            right: 50px / $ppr;
            // top:293px/$ppr;
            bottom: 0;

            .day {
                background: #e9a853;
            }
        }
    }
}

.jj {
    background: url("./img/jj.png");
    background-size: 100% 100%;
}

.yx {
    background: url("./img/ys.png");
    background-size: 100% 100%;
}

.share {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 20px / $ppr 0;

    p {
        width: 660px / $ppr;
        height: 80px / $ppr;
        margin: 0 auto;
        line-height: 80px / $ppr;
        text-align: center;
        color: #fff;
        font-size: 32px / $ppr;
        font-weight: 500;
        background: #5e89ef;
        border-radius: 40px / $ppr;
    }
}

.nolist {
    text-align: center;
    line-height: 96px / $ppr;
    font-size: 28px / $ppr;
    color: #d91c0b;
}
</style>
